import { protectRoutes } from 'components/desktop/_general/ProtectedRoute/ProtectedRoute';
import Dashboard from 'containers/desktop/Dashboard/Dashboard';
import Help from 'containers/desktop/Help/Index';
import KnowledgeBases from 'containers/desktop/KnowledgeBases/Index';
import SystemInfo from 'containers/desktop/SystemInfo/SystemInfo';

const routes = [
	{
		path: '/dashboard',
		element: <Dashboard />,
		permissions: [],
		resources: ['allergens', 'seasons'],
	},
	{
		path: '/systemInfo',
		element: <SystemInfo />,
		permissions: [],
	},
	{
		path: '/airflow/help',
		element: <Help />,
		permissions: [],
	},
	{
		path: '/airflow/knowledge-base',
		element: <KnowledgeBases />,
		permissions: [],
	},
];

export default protectRoutes(routes);
